<template>
  <page-header />
  <a-layout>
    <a-layout-content class="product-list-container">
      <!-- 加载状态 -->
      <a-spin v-if="loading" size="large" class="loading" />

      <!-- 商品列表 -->
      <template v-else >
          <a-card
              v-for="product in products"
              :key="product.id"
              hoverable
              class="product-item"
              @click="goToDetail(product.id)"
          >
            <template #cover>
              <a-image
                  :width="200"
                  :src="product.image"
                  :alt="product.name"
                  :fallback="imageErr"
                  :preview="false"
                  class="product-image"
              />
            </template>
            <a-card-meta :title="product.name">
              <template #description>
                <div class="product-price">¥{{ product.price.toFixed(2) }}</div>
              </template>
            </a-card-meta>
          </a-card>
      </template>

      <!-- 分页组件 -->
      <a-pagination
          v-model:current="searchParams.index"
          v-model:pageSize="searchParams.size"
          :total="totalCount"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="['10', '20', '30', '40']"
          @change="fetchProducts"
          @showSizeChange="fetchProducts"
          class="pagination"
      />
    </a-layout-content>
    <a-layout-footer :style="{ textAlign: 'center' }">
      <icp />
    </a-layout-footer>
  </a-layout>
</template>

<script>
import { defineComponent, ref } from 'vue';
import request from '@/utils/request';
import PageHeader from '@/components/header.vue'
import Icp from '@/components/icp.vue'
import { message } from 'ant-design-vue'
import imageErr from '@/assets/image_err.png'

export default defineComponent({
  components: {
    Icp,
    PageHeader
  },
  setup() {
    const loading = ref(true);
    const products = ref([]);
    const totalCount = ref(0);
    const searchParams = ref({
      index: 1,
      size: 20,
      search: ''
    });

    const fetchProducts = async () => {
      try {
        loading.value = true;
        const response = await request.get('/product/page', {
          params: searchParams.value
        });
        products.value = response.data.rows || [];
        totalCount.value = response.data.count || 0;
      } catch (err) {
        console.error('获取商品数据失败:', err);
        message.error('获取商品数据失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };

    // 跳转到商品详情页
    const goToDetail = (id) => {
      const url = `/product/detail?id=${id}`;
      window.open(url, '_blank');
    };

    // 组件创建时获取数据
    fetchProducts();

    return {
      loading,
      products,
      totalCount,
      searchParams,
      fetchProducts,
      goToDetail,
      imageErr
    };
  }
});
</script>
<style src="./index.css" lang="css" scoped></style>
